import { render, staticRenderFns } from "./detail-tracking-info.vue?vue&type=template&id=7253d427&"
import script from "./detail-tracking-info.vue?vue&type=script&lang=js&"
export * from "./detail-tracking-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports